import * as React from 'react';
import clsx from 'clsx';
import { Base } from '../Base';
import DrawerContext from './DrawerContext';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "root": "DrawerHeader-root_EBaDT"
};
function DrawerHeader({
  heading,
  children,
  className,
  ...extraProps
}) {
  const context = React.useContext(DrawerContext);
  return /*#__PURE__*/_jsxs(Base, {
    tagName: "header",
    flexNone: true,
    backgroundColor: "white",
    className: clsx(styles.root, className),
    ...extraProps,
    children: [/*#__PURE__*/_jsx(Base, {
      id: context?.labelId,
      tagName: "h3",
      size: "big",
      margin: "none",
      children: heading
    }), children]
  });
}
export default DrawerHeader;